import { render, staticRenderFns } from "./FeedbackInvoicesPDV.vue?vue&type=template&id=6a1c118b&scoped=true&"
import script from "./FeedbackInvoicesPDV.vue?vue&type=script&lang=ts&"
export * from "./FeedbackInvoicesPDV.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackInvoicesPDV.vue?vue&type=style&index=0&id=6a1c118b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1c118b",
  null
  
)

export default component.exports